import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { FolderDto, TenantDto } from '@nusign/picflow-backend-types';
import { map } from 'rxjs';
import { PICFLOW_CONFIG } from '../picflow-config';
import { ObservableDataLoaderService } from './observable-data-loader.service';

@Injectable({
  providedIn: 'root',
})
export class FoldersCommonService {
  private observableLoader = inject(ObservableDataLoaderService);
  private config = inject(PICFLOW_CONFIG);
  private http = inject(HttpClient);

  public getTenantInfoFromFolder(folderId: string, tenantId: string) {
    return this.observableLoader.get('folder-tenant-info_' + tenantId, () => {
      const url = `${this.config.apiEndpoint}/folders/${folderId}?include[]=tenant_product_name&ignore_401_error=true&expand[]=tenant`;
      return this.http.get<FolderDto>(url).pipe(
        map(gallery => {
          return {
            id: tenantId,
            planName: undefined, //gallery.tenant_product_name,
            tenant: gallery.tenant as TenantDto,
          };
        })
      );
    });
  }
}
